export default "__VITE_ASSET__C8mQdF_7__"